import { useEffect, useState } from "react";
import api from "@/api";
import { MapPin } from "lucide-react";

export default function CoveragePage() {
  const [items, setItems] = useState([]);
  const [scope, setScope] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/coverage").then((r) => {
      setItems(r.data.items || []);
      setScope(r.data.scope);
    }).finally(() => setLoading(false));
  }, []);

  const max = items.reduce((m, x) => Math.max(m, x.volunteers || 0), 0) || 1;

  return (
    <div className="space-y-6" data-testid="coverage-page">
      <div>
        <span className="tracking-label text-blue-700">Cobertura territorial</span>
        <h1 className="mt-2 font-display font-black text-3xl text-slate-900">Mapa de cobertura</h1>
        <p className="text-sm text-slate-600 mt-1">
          Distribución de voluntarios por sección electoral y colonia.
        </p>
      </div>

      <div className="surface-card p-6">
        {loading ? (
          <div className="text-slate-500 text-center py-8">Cargando…</div>
        ) : items.length === 0 ? (
          <div className="text-center py-12">
            <MapPin className="w-10 h-10 mx-auto text-slate-400" />
            <p className="mt-3 text-slate-600">Sin voluntarios registrados todavía.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2" data-testid="coverage-grid">
            {items.slice(0, 200).map((it, i) => {
              const intensity = (it.volunteers / max) * 100;
              return (
                <div
                  key={i}
                  className="relative rounded p-3 border border-slate-200 hover:border-slate-400 transition-colors min-h-[88px] flex flex-col justify-between"
                  style={{ backgroundColor: `rgba(37, 99, 235, ${0.06 + (intensity / 100) * 0.45})` }}
                  data-testid={`section-cell-${it.seccion}`}
                  title={`${it.colonia || it.municipio || ""} · ${it.volunteers} voluntarios`}
                >
                  <div className="tracking-label text-slate-500">Sección</div>
                  <div className="font-display font-black text-xl text-slate-900">{it.seccion}</div>
                  <div className="text-[10px] text-slate-700 truncate">{it.colonia || it.municipio}</div>
                  <div className="absolute top-2 right-2 text-xs font-bold text-blue-700">{it.volunteers}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {items.length > 0 && (
        <div className="surface-card overflow-hidden">
          <div className="px-6 py-3 border-b border-slate-200 tracking-label text-slate-500">Detalle</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 border-b border-slate-200">
                <tr>
                  <th className="px-4 py-3 text-left tracking-label text-slate-500 font-medium">Sección</th>
                  <th className="px-4 py-3 text-left tracking-label text-slate-500 font-medium">{scope === "region" ? "Colonia" : "Municipio"}</th>
                  <th className="px-4 py-3 text-left tracking-label text-slate-500 font-medium">Voluntarios</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it, i) => (
                  <tr key={i} className="border-b border-slate-100">
                    <td className="px-4 py-2 font-medium">{it.seccion}</td>
                    <td className="px-4 py-2">{it.colonia || it.municipio}</td>
                    <td className="px-4 py-2 font-bold">{it.volunteers}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
